import React from 'react';
import classNames from 'classnames';
import css from './Checkbox.module.css';

/**
 * Custom Checkbox component matching shadcn/ui design
 * Built with vanilla React + CSS Modules
 */
export const Checkbox = ({
  id,
  checked = false,
  onCheckedChange,
  disabled = false,
  className,
  ...props
}) => {
  const handleChange = (e) => {
    if (onCheckedChange && !disabled) {
      onCheckedChange(e.target.checked);
    }
  };

  return (
    <label className={classNames(css.checkboxWrapper, className)}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className={css.checkboxInput}
        {...props}
      />
      <span className={css.styledCheckbox}>
        {checked && (
          <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" className={css.checkmark}>
            <path
              fill="white"
              d="M5.636621 10.7824771L3.3573694 8.6447948c-.4764924-.4739011-.4764924-1.2418639 0-1.7181952.4777142-.473901 1.251098-.473901 1.7288122 0l1.260291 1.1254782 2.8256927-4.5462307c.3934117-.5431636 1.1545778-.6695372 1.7055985-.278265.5473554.3912721.6731983 1.150729.2797866 1.6951077l-3.6650524 5.709111c-.2199195.306213-.5803433.5067097-.9920816.5067097-.3225487 0-.6328797-.1263736-.8637952-.3560334z"
            />
          </svg>
        )}
      </span>
    </label>
  );
};
